export const variantLineItemsMap = <T extends { horse_variant_id: number }>(lineItems: T[]): Record<number, T & { sortIndex: number }> =>
  Object.fromEntries(lineItems.map((lineItem, sortIndex) => [lineItem.horse_variant_id, { ...lineItem, sortIndex }]));

export const variantLineItemIdentity = ({ id, horse_variant_id }: { id: number | null; horse_variant_id: number }):
  { id: number } | { horse_variant_id: number } => id === null ? { horse_variant_id } : { id };

export const removedVariantIds = <T>(original: Record<number, T>, current: Record<number, T>): number[] =>
  Object.keys(original).map(Number).filter((id) => !(id in current));

export const appendVariantLineItems = <T extends { horse_variant_id: number; sortIndex: number }>(
  current: Record<number, T>, added: Record<number, T>,
): Record<number, T> => variantLineItemsMap([
  ...sortedVariantLineItems(current),
  ...sortedVariantLineItems(added).filter(({ horse_variant_id }) => !(horse_variant_id in current)),
]);

export const sortedVariantLineItems = <T extends { sortIndex: number }>(lineItems: Record<number, T>): T[] =>
  Object.values(lineItems).sort((left, right) => left.sortIndex - right.sortIndex);
